export function crmChildObjectAndRelationSelect() {
  return {
    restrict: 'E',
    template: require('./crm-child-object-and-relation-select.directive.html'),
    scope: {
      companyId: '<',
      organizationId: '<',
      entry: '=',
      objectsDescriptions: '=',
      contactObjectName: '<'
    },
    controller: controller
  };
}

controller.$inject = ['$scope', 'CrmFactory'];
function controller($scope, CrmFactory) {
  function selectRelationsToContactFields() {
    if (!$scope.entry.child_object_name) {
      return;
    }
    CrmFactory.loadObjectDescription($scope.companyId, $scope.organizationId, $scope.entry.child_object_name, $scope.objectsDescriptions)
      .then(
        () => {
          $scope.relationToContactFields = $scope.objectsDescriptions[$scope.entry.child_object_name].fields.filter(
            field => field.type == 'reference' && field.referenceTo.some(
              referenceTo => referenceTo == $scope.contactObjectName)
          );
        }
      );
  }

  selectRelationsToContactFields();

  $scope.onChildObjectNameUpdated = () => {
    selectRelationsToContactFields();
    $scope.entry.field_name = '';
    $scope.entry.field_type = '';
    $scope.entry.display_label = '';
    $scope.entry.search_type = '';
    $scope.entry.child_relationship_name = '';
    $scope.entry.child_relationship_field_name = '';
  };

  $scope.onChildObjectRelationshipUpdated = () => {
    let field = $scope.objectsDescriptions[$scope.entry.child_object_name].fields.find(field => field.relationshipName == $scope.entry.child_relationship_name);
    $scope.entry.child_relationship_field_name = field.name;
  };

  $scope.selectContactRelationTranslateKey = 'crm/organizations/configuration/select-' + $scope.contactObjectName + '-relation';

}
